import React, { useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import { styled } from '@mui/system';
import { useLocation } from 'react-router-dom';


const StyledLinearProgress = styled(LinearProgress)`
    position: fixed;
    width:100%;
    background-color: ${(({ theme }) => theme.palette.background.default)};
    z-index: ${(({ theme }) => {
        // console.log("this is theme object", theme)
        return (theme.zIndex.drawer - 1)
    })};

    .MuiLinearProgress-bar {
        background-color: ${(({ theme }) => theme.palette.background.progressBar)};
    }
    
    `


export default function ProgressStatus() {
    // const classes = useStyles();
    const [progress, setProgress] = useState(0);

    const location = useLocation();
    useEffect(() => {
        // if (ffirst.current === false) return null
        setProgress(0);
    }, [location])

    useEffect(() => {
        let wrappedElement = document.getElementById('content-container');
        let computeProgress = () => {

            try {
                const scrollLength = window.innerHeight
                const scrolled = wrappedElement.getBoundingClientRect().bottom
                const progress = 100 * (scrollLength - (scrolled - scrollLength * (Math.round(scrolled / scrollLength) == 0 ? 1 : scrolled / scrollLength))) / scrolled;
                setProgress(progress > 100 ? 100 : progress);
            } catch (err) {
                console.log(err, "error in progress bar. setting progress to 0")
                setProgress(0);
            }
        }
        // console.log("this is scrolled progress", progress)
        // Adding event listener on mounting
        wrappedElement && window.addEventListener("scroll", computeProgress, true);

        // Removing event listener upon unmounting
        return () => window.removeEventListener("scroll", computeProgress);
    });

    return (
        <div >
            <StyledLinearProgress
                variant="determinate"
                value={progress}
            />
        </div>
    );
}
